module.exports = __webpack_public_path__ + "img/limited-time-award-4.46b94671.png";